// @ts-nocheck

import { filter, isEmpty, reduce, size } from 'lodash';
import { createSelector } from 'reselect';

import { selectBasketItems, selectBasketMode, selectBasketStatus } from '../../selectors/basket/basketPrimary.selector';
import { BasketItemStatuses, BasketModes, BasketStatuses } from '../../types/basket';

const getPendingItemsCount = createSelector([selectBasketStatus, selectBasketItems], (basketStatus, items) => {
  if (basketStatus === BasketStatuses.VALIDATED || basketStatus === BasketStatuses.WAITING) {
    return 0;
  } else {
    return size(
      filter(items, (x) => x.status !== BasketItemStatuses.VALIDATED && x.status !== BasketItemStatuses.WAITING),
    );
  }
});

const getTotalOdd = createSelector([selectBasketMode, selectBasketItems], (mode, items) => {
  let result = 0;

  // On retourne une cote si:
  // - On a un panier combo
  // - On a un seul pari dans un panier simple
  if ((mode === BasketModes.COMBINED && !isEmpty(items)) || (mode === BasketModes.SIMPLE && size(items) === 1)) {
    result = reduce(
      items,
      (acc, { value, validatedValue }) => {
        return acc * (validatedValue || value);
      },
      1,
    );
    result = Math.round(result * 100) / 100;
  }

  return result;
});

const selectFloatingBasketButtonProps = createSelector(
  [getTotalOdd, getPendingItemsCount],
  (totalOdds, nbBasketItems) => ({
    totalOdds,
    nbBasketItems,
  }),
);

export default selectFloatingBasketButtonProps;
